import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'BrokenCosmos Labs';
const SITE_URL = 'https://brokencosmos.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const normalizePath = (path = '/') => {
	if (!path.startsWith('/')) {
		return `/${path}`;
	}

	if (path.length > 1 && path.endsWith('/')) {
		return path.slice(0, -1);
	}

	return path;
};

const buildCanonicalUrl = (path) => `${SITE_URL}${normalizePath(path)}`;

const Seo = ({
	title,
	description,
	path = '/',
	type = 'website',
	image = DEFAULT_IMAGE,
	imageAlt = `${SITE_NAME} logo`,
	noIndex = false,
	jsonLd,
	publishedTime,
	modifiedTime,
	author,
}) => {
	const canonicalUrl = buildCanonicalUrl(path);
	const robotsContent = noIndex ? 'noindex, nofollow' : 'index, follow';

	return (
		<Helmet prioritizeSeoTags>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="robots" content={robotsContent} />
			<link rel="canonical" href={canonicalUrl} />

			<meta property="og:site_name" content={SITE_NAME} />
			<meta property="og:locale" content="en_US" />
			<meta property="og:type" content={type} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={image} />
			<meta property="og:image:alt" content={imageAlt} />

			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
			<meta name="twitter:url" content={canonicalUrl} />

			{publishedTime ? <meta property="article:published_time" content={publishedTime} /> : null}
			{modifiedTime ? <meta property="article:modified_time" content={modifiedTime} /> : null}
			{author ? <meta property="article:author" content={author} /> : null}
			{jsonLd ? (
				<script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
			) : null}
		</Helmet>
	);
};

export default Seo;
